<!--------------------------------------------------
  システム名：弁当注文ビフォサック
  プログラム名：App.vue
  モジュール名：ルートコンポーネント
  備考：
-------------------------------------------------->
<template>
  <!-- 2026.08.21 V2.2 AI ADD START チケット#14434 弁当業者向け閲覧機能は管理画面の共通ヘッダー
       （システムバー）・共通背景色を使わない単独ページのため、ルート名で分岐する -->
  <v-app :class="{ 'gyosha-view-app': $route.name === 'GyoshaOrderView' }">
    <!-- システムバー -->
    <base-system-bar v-if="$route.name !== 'GyoshaOrderView'" />
    <!-- 2026.08.21 V2.2 AI ADD END -->
    <!-- スナックバー -->
    <base-snack-bar ref="snackbar" />
    <!-- 確認ダイアログ -->
    <confirm-dialog ref="confirm" />
    <!-- 2025.04.10 MCS)SAITO ADD START -->
    <!-- 警告ダイアログ -->
    <warning-dialog ref="warning" />
    <!-- 2025.04.10 MCS)SAITO ADD END -->
    <!-- 画面コンポーネント -->
    <router-view />
  </v-app>
</template>

<script>
import BaseSystemBar from "./components/bases/BaseSystemBar";
import BaseSnackBar from "./components/bases/BaseSnackBar";
import ConfirmDialog from "./components/templates/ConfirmDialog";
/* 2025.04.10 MCS)SAITO ADD START */
import WarningDialog from "./components/templates/WarningDialog";
/* 2025.04.10 MCS)SAITO ADD END */

export default {
  components: {
    BaseSystemBar,
    BaseSnackBar,
    ConfirmDialog,
    /* 2025.04.10 MCS)SAITO ADD START */
    WarningDialog,
    /* 2025.04.10 MCS)SAITO ADD END */
  },
  mounted() {
    this.$root.confirm = this.$refs.confirm;
    this.$root.snackbar = this.$refs.snackbar;
    /* 2025.04.10 MCS)SAITO ADD START */
    this.$root.warning = this.$refs.warning;
    /* 2025.04.10 MCS)SAITO ADD END */
  },
};
</script>
